/**
 * 定额管理路由
 */
const QuotaInfoRouter = {
  path: 'quotaInfo',
  name: 'QuotaInfo',
  meta: {
    requiresAuth: false,
    leftMenu: true          // false表示不需要左边菜单栏
  },
  component: () => import('@/views/QuotaInfo/index')
}
export default QuotaInfoRouter
